import React from 'react'

const Target = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="29"
    viewBox="0 0 30 29"
  >
    <g>
      <g transform="matrix(-1 0 0 1 30 0)">
        <g>
          <path
            fill="#3a3a3a"
            d="M15.752 14.505c-.005-.005-.006-.012-.011-.017l-5.054-5.054V6.258a.885.885 0 0 0-.26-.626L5.113.259a.886.886 0 0 0-1.511.627v2.656H.886A.884.884 0 0 0 .26 5.054l5.372 5.373c.166.166.391.26.627.26h3.175l5.054 5.053c.005.005.012.007.018.012a.87.87 0 0 0 1.218 0c.367-.352.36-.9.028-1.247z"
          />
        </g>
        <g>
          <path
            fill="#3a3a3a"
            d="M15 0c-2.249 0-4.375.553-6.29 1.417l2.696 2.606A11.72 11.72 0 0 1 15 3.455c6.3 0 11.426 4.955 11.426 11.045S21.3 25.545 15 25.545 3.574 20.59 3.574 14.5c0-1.214.212-2.38.588-3.474L1.466 8.42C.572 10.27 0 12.326 0 14.5 0 22.464 6.761 29 15 29s15-6.536 15-14.5S23.239 0 15 0z"
          />
        </g>
        <g>
          <path
            fill="#3a3a3a"
            d="M15 6c-1.057 0-2.057.205-3 .522V7.66l2.312 2.184c.227-.03.452-.066.688-.066 2.757 0 5 2.118 5 4.722 0 2.604-2.243 4.722-5 4.722s-5-2.118-5-4.722c0-.223.038-.436.07-.65l-2.312-2.183H6.553C6.217 12.557 6 13.502 6 14.5c0 4.687 4.037 8.5 9 8.5s9-3.813 9-8.5C24 9.813 19.963 6 15 6z"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default Target
